// src/pages/CourseTime/components/slides/common/NoDataFallback.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import SlideTitleSpoken from './SlideTitleSpoken.comp';

// Fallback: structured data missing (older content) → render HTML.
// Shared by Recap / ReentryMap / WorkedExample / DecisionPoint / AnalysisFramework.
const NoDataFallback = ({ slide, skipTitleSpeech, renderSpokenText, renderContent }) => (
  <S.SlideDescription>
    <S.SlideTitle>
      <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
    </S.SlideTitle>
    <S.PointText>{renderContent('content_0', slide.SlideContent)}</S.PointText>
  </S.SlideDescription>
);

export default NoDataFallback;
